<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          ลืมรหัสผ่าน
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn> </v-card-title
        ><v-card-text class="pb-0">
          <v-row justify="center" align="center">
            <v-col justify="center" align="center">
              <v-container fluid>
                <v-card>
                  <v-card-text>
                    <v-form ref="form">
                      <v-row
                        ><h4 class="pl-3">ชื่อผู้ใช้งาน</h4>
                        <v-col cols="12">
                          <v-text-field
                            v-model="username"
                            label="กรอกชื่อผู้ใช้งาน"
                            outlined
                            :rules="userRules"
                          ></v-text-field>
                        </v-col>

                        <h4 class="pl-3">อีเมล</h4>
                        <v-col cols="12">
                          <v-text-field
                            v-model="email"
                            label="กรอกอีเมล"
                            outlined
                            :rules="emailRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-col> </v-row
        ></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="show_loading"
            class="white--text"
            style="background-color: #ff3333"
            text
            @click="dialog = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            :loading="show_loading"
            text
            class="white--text"
            style="background-color: #009fa6"
            @click="forgetPassword()"
            >ยืนยัน</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="reset_password_dialog"
      persistent
      content-class="round"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>ตั้งรหัสผ่านใหม่
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-form ref="reset_password_form" @submit.prevent="resetPassword()">
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h5 class="text-center">
                  <font color="error">** กรุณาตั้งรหัสผ่านใหม่ **</font>
                </h5>
              </v-col>
              <v-col cols="10" align="center" justify="center">
                <v-text-field
                  v-model="new_password"
                  name="new_password"
                  label="รหัสผ่านใหม่"
                  type="password"
                  outlined
                  dense
                  :rules="rule_new_password"
                ></v-text-field>
              </v-col>
              <v-col cols="10" align="center" justify="center">
                <v-text-field
                  v-model="confirm_new_password"
                  name="confirm_new_password"
                  label="ยืนยันรหัสผ่าน"
                  type="password"
                  outlined
                  dense
                  :rules="rule_confirm_new_password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            style="background-color: #ff3333"
            @click="close()"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="white--text"
            style="background-color: #009fa6"
            type="submit"
            @click="resetPassword()"
            >ยืนยัน</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="alert_nodata"
      persistent
      content-class="round"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-text
          dark
          class="white--text font-weight-bold text-center py-1"
          style="
            background: #ff3333;
            font-size: 18px;
            font-family: 'sukhumvit_setsemi_bold';
          "
        >
          <v-row align="center"
            ><v-col class="py-0 pl-8" cols="11">กู้คืนรหัสผ่านผิดพลาด !</v-col
            ><v-col class="py-0" cols="1"
              ><v-btn icon class="float-right" @click="alert_nodata = false"
                ><v-icon color="white">mdi-close</v-icon></v-btn
              ></v-col
            >
          </v-row>
        </v-card-text>
        <v-card-text
          class="grey--text text-center py-1"
          style="line-height: 1.8"
          ><h1 class="py-4">
            <v-icon size="100" color="#ff3333">fas fa-frown</v-icon>
          </h1>
          <h3 class="font-weight-bold">ไม่สามารถกู้คืนรหัสผ่านได้</h3>
          <h3 class="font-weight-bold">
            เนื่องจากชื่อผู้ใช้งาน หรือ อีเมลไม่ถูกต้อง
          </h3>
          <h4 class="font-weight-light">
            กรุณาติดต่อ Call Center หากต้องการความช่วยเหลือ
          </h4>
          <h5 class="font-weight-light">เบอร์โทรติดต่อ 074-451651</h5>
          <h5 class="font-weight-light">
            ( เวลาเปิดทำการ จันทร์-ศุกร์ 08.30-16.30 น. )
          </h5>
          <h5 class="font-weight-light">
            หรือติดต่อสำนักงานสาขาวิชาวิสัญญีวิทยา
          </h5></v-card-text
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            style="background-color: grey"
            @click="alert_nodata = false"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      alert_nodata: false,
      reset_password_dialog: false,
      dialog: false,
      show_loading: false,
      username: "",
      email: "",
      user_id: 0,
      new_password: "",

      confirm_new_password: "",
      rule_new_password: [
        (v) => !!v || "กรุณากรอกรหัสผ่าน",
        (v) => v.length >= 4 || "* รหัสผ่านควรมีความยาวอย่างน้อย 4 ตัว",
        (v) =>
          /^([A-Za-z0-9])+$/.test(v) ||
          "* กรุณาใส่รหัสผ่านเป็นภาษาอังกฤษหรือตัวเลข",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      rule_confirm_new_password: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => v == this.new_password || "รหัสผ่านไม่ถูกต้อง",
      ],
      emailRules: [
        (v) => !!v || "* กรุณากรอกอีเมล",
        (v) => !/([ก-๏ ])/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+([A-Za-z])+$/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+([A-Za-z])+$/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      userRules: [
        (v) => !!v || "* กรุณากรอกชื่อผู้ใช้",
        (v) => v.length >= 4 || "* ชื่อผู้ใช้ควรมีความยาวอย่างน้อย 4 ตัว",
        (v) =>
          /^([A-Za-z0-9])+$/.test(v) ||
          "* กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษหรือตัวเลข",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
    };
  },
  methods: {
    openDialogForgetPassword() {
      // console.log(this.$session.getAll());
      this.dialog = true;
      this.username = "";
      this.email = "";
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
    },
    close() {
      this.new_password = "";
      this.confirm_new_password = "";
      this.reset_password_dialog = false;
    },
    openDialogResetPassword() {
      this.new_password = "";
      this.confirm_new_password = "";
      setTimeout(() => {
        this.$refs.reset_password_form.resetValidation();
      }, 100);

      this.reset_password_dialog = true;
    },
    forgetPassword() {
      if (this.$refs.form.validate()) {
        let data = {
          username: this.username,
          email: this.email,
        };
        // console.log(data);
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/checkuser",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response);
            if (response.data === "Not found") {
              // this.$swal.fire(
              //   "ข้อมูลไม่ถูกต้อง !",
              //   "กรุณาลองใหม่อีกครั้ง",
              //   "warning"
              // );
              this.alert_nodata = true;
              setTimeout(() => {
                this.alert_nodata = false;
              }, 8000);
            } else {
              // console.log("id : " + response.data);
              this.user_id = response.data;
              this.reset_password_dialog = true;
            }
          });
      } else {
        this.$swal.fire(
          "ข้อมูลไม่สมบูรณ์ !",
          "กรุณาตรวจสอบใหม่อีกครั้ง",
          "warning"
        );
      }
    },
    resetPassword() {
      if (this.$refs.reset_password_form.validate()) {
        let data = {
          id: this.user_id,
          password: this.new_password,
        };
        // console.log(data);
        this.axios
          .put(process.env.VUE_APP_API + "/api/v1/forgetpassword", data)
          .then((response) => {
            // console.log(response.data);
            if (response.data == "edit success") {
              this.$swal.fire("ตั้งรหัสผ่านใหม่สำเร็จ", "", "success");
              this.reset_password_dialog = false;
              this.dialog = false;

              this.$router.push("/login");
            } else {
              // this.$swal.fire(
              //   "พบข้อผิดพลาด !",
              //   "กรุณาลองใหม่อีกครั้ง",
              //   "error"
              // );
            }
          });
      } else if (this.new_password == "" || this.confirm_new_password == "") {
        this.$swal.fire(
          "ข้อมูลไม่สมบูรณ์ !",
          "กรุณาตรวจสอบใหม่อีกครั้ง",
          "warning"
        );
      } else {
        this.$swal.fire(
          "กรุณากรอกรหัสผ่านใหม่",
          "รหัสทั้งสองช่องไม่ตรงกัน",
          "warning"
        );
      }
    },
  },
};
</script>